import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PipIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M20.1 2C22.26 2 24 3.73 24 5.86v11.28A3.9 3.9 0 0 1 20.1 21H3.9a4 4 0 0 1-2.76-1.13A3.8 3.8 0 0 1 0 17.14V5.86c0-.99.38-1.93 1.07-2.65a4 4 0 0 1 2.61-1.2L3.9 2zm0 1.78H3.73A2.1 2.1 0 0 0 1.8 5.86v11.28c0 1.15.94 2.08 2.1 2.08h16.2c1.16 0 2.1-.93 2.1-2.08V5.86c0-1.15-.94-2.08-2.1-2.08" /><path d="M21 12.42c0-.78-.65-1.42-1.46-1.42h-6.16q-.57.04-.98.45-.4.4-.4.97v4.16q0 .59.43 1c.27.27.64.42 1.03.42h6.08c.8 0 1.46-.63 1.46-1.42z" />
    </SvgIcon>
);
